<template>
  <div id="app">
    <div class="">
      <div class="container">
        <b-form inline style="display: block !important;">
          <div style="text-align: center">
            <label class="sr-only"></label>
            <b-form-input :state="state" v-model="email" aria-describedby="input-live-help input-live-feedback"
                          class="mb-2 mr-sm-2 mb-sm-0" placeholder="Email">
            </b-form-input>
            <b-button :disabled="!email || showLoader || !state" variant="primary" @click="onClick()">
              <b-spinner v-if="showLoader" small label="Spinning"></b-spinner>
              Subscribe
            </b-button>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>

<script>

import Swal from 'sweetalert2'
import axios from "axios";

export default {
  props: {
    accountId: {
      type: String
    },
    eventAction: {
      type: String
    },
    eventParams: {
      type: String
    }
  },
  data() {
    return {
      email: '',
      showLoader: false
    }
  },
  computed: {
    state() {
      if (!this.email) {
        return null
      }
      return this.isEmailValid(this.email)
    },
  },
  methods: {
    isEmailValid(email) {
      const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/igm
      return emailRegexp.test(email);
    },
    async onClick() {
      try {
        this.showLoader = true
        const data = {email: this.email, landingPageUrl: window.location.href, domain: window.location.host};
        await axios.post(`/${this.accountId}/othersubscriber`, data)
        this.sendEvent();
        Swal.fire('Success',
            'Subscribed Successfully',
            'success')
        this.email = '';
      } catch (e) {
        Swal.fire('Error',
            'Something went wrong. Please try again',
            'error')
      } finally {
        this.showLoader = false
      }
    },
    async sendEvent() {
      try {
        const action = this.eventAction || 'conversion';
        const eventParams = this.getEventParams()
        this.$gtag.event(action, eventParams)
      } catch (e) {
        console.log(e)
      }
    },
    getEventParams() {
      let eventParams = {'send_to': 'AW-479042981/N1h_CLeb1P0CEKW7tuQB'}
      if (this.eventParams) {
        try {
          console.log(this.eventParams)
          eventParams = JSON.parse(this.eventParams)
        } catch (e) {
          console.log(e)
        }
      }
      return eventParams;
    }
  },
  name: 'App',
  mounted() {
  },
}

</script>
